export default "__VITE_ASSET__0c0bafbe__"